import React from 'react';
import { Box, Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class OverviewMonthSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      sales_total: [],
      filterData: {}
    };

    this.getData = this.getData.bind(this);
    this.doSync = this.doSync.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    let queryData = {};
    let data = BackofficeReportsApi.getSalesSummary(this.state.client, queryData);

    if (data) {
      this.setState({ sales_total: data });
    }

    this.setState({ filterData: queryData });
  }

  doSync() {
    this.getData();
  }

  render() {
    let salesTYV = 0;
    let salesLYV = 0;
    let salesTodayTY = 0;
    let salesTodayLY = 0;
    let diff_salesV = 0;
    let diff_posV = false;

    if (this.state.sales_total) {
      let sales_total = this.state.sales_total;

      if (sales_total.sales_TY !== undefined) salesTYV = parseInt(sales_total.sales_TM);
      if (sales_total.sales_LY !== undefined) salesLYV = parseInt(sales_total.sales_TMLY);
      if (sales_total.sales_Today !== undefined) salesTodayTY = parseInt(sales_total.sales_Today);
      if (sales_total.sales_TodayLY !== undefined) salesTodayLY = parseInt(sales_total.sales_TodayLY);

      if ((salesLYV - salesTodayLY) > 0) {
        diff_salesV = parseFloat(
          ((salesTYV - salesTodayTY) / (salesLYV - salesTodayLY) - 1) * 100
        ).toFixed(1);
      }

      diff_posV = diff_salesV >= 0;
    }

    const displayValue =
      salesTYV > 1000000
        ? thousandsSeparator((salesTYV / 1000000).toFixed(1)) + "M"
        : thousandsSeparator((salesTYV / 1000).toFixed(1)) + "K";

    return (
      <Card
        sx={{
          overflow: 'hidden',
          position: 'relative',
          borderRadius: { xs: '14px', sm: '16px' },
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          background: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: '#1a237e',
          },
        }}
      >
        <CardContent
          sx={{
            height: '100%',
            boxSizing: 'border-box',
            p: {
              xs: 1.35,
              sm: 1.6,
              md: 1.75,
            },
            '&:last-child': {
              pb: {
                xs: 1.35,
                sm: 1.6,
                md: 1.75,
              },
            },
          }}
        >
          <Stack
            sx={{
              height: '100%',
              minHeight: {
                xs: 104,
                sm: 118,
              },
            }}
            justifyContent="space-between"
            spacing={1.1}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  lineHeight: 1.2,
                  color: '#1a237e',
                  fontWeight: 800,
                  letterSpacing: '.015em',
                  fontSize: {
                    xs: '0.72rem',
                    sm: '0.78rem',
                    md: '0.82rem',
                  },
                  textTransform: 'uppercase',
                }}
              >
                Sales this month
              </Typography>

              <Typography
                sx={{
                  mt: 0.55,
                  fontWeight: 800,
                  lineHeight: 1,
                  color: '#111827',
                  fontSize: {
                    xs: '1.9rem',
                    sm: '2.1rem',
                    md: '2.25rem',
                  },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {displayValue}
              </Typography>
            </Box>

            <Stack
              alignItems="center"
              direction="row"
              spacing={0.65}
              sx={{ minWidth: 0 }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.3,
                  px: 0.65,
                  py: 0.25,
                  borderRadius: 999,
                  bgcolor: diff_posV
                    ? 'rgba(46, 125, 50, 0.10)'
                    : 'rgba(211, 47, 47, 0.10)',
                  flexShrink: 0,
                }}
              >
                <SvgIcon
                  color={diff_posV ? 'success' : 'error'}
                  sx={{ fontSize: 17 }}
                >
                  {diff_posV ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                </SvgIcon>

                <Typography
                  color={diff_posV ? 'success.main' : 'error.main'}
                  sx={{
                    fontWeight: 800,
                    fontSize: {
                      xs: '0.8rem',
                      sm: '0.86rem',
                    },
                    lineHeight: 1.2,
                  }}
                >
                  {diff_salesV}%
                </Typography>
              </Box>

              <Typography
                color="text.secondary"
                sx={{
                  fontSize: {
                    xs: '0.74rem',
                    sm: '0.8rem',
                  },
                  lineHeight: 1.25,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                }}
              >
                vs. last year
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default OverviewMonthSales;
